import { createActionsHook, createStore, type BoundActions, type HookActionsFunction, type Store, type StoreActionApi } from 'react-sweet-state';

import { type ConversationAction } from '@atlassian/rovo-conversation-actions/types';

export type AISmartButtonState = {
	buttonClickedTimestamp?: number;
	nudges: ConversationAction[];
};

export const initialState: AISmartButtonState = {
	nudges: [],
};

export const actions = {
	setNudges:
		(nudges: ConversationAction[]) =>
		({ setState }: StoreActionApi<AISmartButtonState>): void => {
			setState({ nudges });
		},
	setButtonClickedTimestamp:
		(buttonClickedTimestamp: number) =>
		({ setState }: StoreActionApi<AISmartButtonState>): void => {
			setState({ buttonClickedTimestamp });
		},
};

export const AISmartButtonStore: Store<AISmartButtonState, {
    setButtonClickedTimestamp: (buttonClickedTimestamp: number) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
    setNudges: (nudges: ConversationAction[]) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
}> = createStore({
	initialState,
	actions,
	name: 'AISmartButtonStore',
});

export const useAISmartButtonActions: HookActionsFunction<BoundActions<AISmartButtonState, {
    setButtonClickedTimestamp: (buttonClickedTimestamp: number) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
    setNudges: (nudges: ConversationAction[]) => ({ setState }: StoreActionApi<AISmartButtonState>) => void;
}>> = createActionsHook(AISmartButtonStore);
export type AISmartButtonActions = ReturnType<typeof useAISmartButtonActions>;
